module.exports = __webpack_public_path__ + "images/24c69f769830672406cc5d0da7fcb0a7.svg";